import _ from "lodash";

const formatDateFields = (order) => {
  Object.keys(order).forEach((key) => {
    if (key?.includes("Date")) {
      order[key] = order[key]
        ? new Date(order[key]).toISOString().split("T")[0]
        : null;
    }
  });
};

const normalizeAttrsToString = (obj) =>
  _.mapValues(
    obj,
    (value) => (value == null ? null : String(value).trim()) // Convert everything to string for loose comparison
  );

const formatNotifications = (notifications) => {
  return notifications?.map((notification) => {
    const orderIdMatch = notification?.message.match(/Order ID: (\d+)/);
    const poNumberMatch =
      notification?.message.match(/PO Number\s*:?\s*([A-Za-z0-9/-]+)/i) ||
      notification?.message.match(/Po Number\s*:?\s*([A-Za-z0-9/-]+)/i);
    const acidNumberMatch = notification?.message.match(
      /ACID Number\s*:?\s*([A-Za-z0-9/-]+)/i
    );
    const orderId = orderIdMatch ? parseInt(orderIdMatch[1], 10) : null;
    const updatedMessage = notification?.message
      .replace(/Order ID: \d+/, "")
      .trim();

    return {
      ...notification,
      subject: notification?.subject.replace(/_/g, " "), // Replace underscores with spaces
      message: updatedMessage, // Update the message without the Order ID
      orderId, // Save the extracted Order ID
      poNumber: notification?.poNumber || poNumberMatch?.[1] || "",
      acidNumber: notification?.acidNumber || acidNumberMatch?.[1] || "",
    };
  });
};
const formatDate = (dateArray) => {
  const [year, month, day, hour, minute, second, nanoseconds] = dateArray;

  const date = new Date(
    year,
    month - 1,  // JS months are 0-based
    day,
    hour,
    minute,
    second,
    Math.floor(nanoseconds / 1_000_000) // ns → ms
  );

  return new Intl.DateTimeFormat("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).format(date);
};


const castOptionsToFitOptionsFilter = (options) =>
  options
    .filter((opt) => !String(opt.id).includes("Select"))
    .map((opt) => ({
      value: opt.id,
      label: opt.name,
    }));



const formatDateUTC = (date) => {
  if (!date) return null;

  const d = typeof date.toDate === "function" ? date.toDate() : new Date(date);

  if (isNaN(d.getTime())) {
    console.error("Invalid date passed to formatDateUTC:", date);
    return null;
  }

  return new Date(
    Date.UTC(
      d.getFullYear(),
      d.getMonth(),
      d.getDate(),
      d.getHours(),
      d.getMinutes(),
      d.getSeconds(),
      d.getMilliseconds()
    )
  ).toISOString();
};

export { formatDateFields, normalizeAttrsToString, formatNotifications, formatDate, formatDateUTC ,castOptionsToFitOptionsFilter };
